import { IColunasSettingsUser } from "@app/shared/utils/validar_settings_user";

export const COLUNAS_DEFAULT_MODULE_EXPEDICAO = [
  {
    module: 'EXP_COMBUSTIVEL',
    colunas: [
      {
        active: true,
        removable: true,
        field: 'codigo'
      },
      {
        active: true,
        removable: false,
        field: 'nome'
      },
      {
        active: true,
        removable: true,
        field: 'valor'
      }
    ]
  },
  {
    module: 'EXP_MARCA',
    colunas: [
      {
        active: true,
        removable: true,
        field: 'codigo'
      },
      {
        active: true,
        removable: false,
        field: 'nome'
      }
    ]
  },
  {
    module: 'EXP_TP_CORREIOS',
    colunas: [
      {
        active: true,
        removable: true,
        field: 'codigo'
      },
      {
        active: true,
        removable: false,
        field: 'nome'
      },
      {
        active: true,
        removable: true,
        field: 'qtd_dias'
      }
    ]
  },
  {
    module: 'EXP_PROPRIETARIO',
    colunas: [
      {
        field: 'parceiro.nome_razao_social',
        active: true,
        removable: false
      },
      {
        field: 'parceiro.apelido_nome_fantasia',
        active: true,
        removable: true
      },
      {
        field: 'parceiro.cpf_cnpj',
        active: true,
        removable: true
      },
      {
        field: 'rntrc',
        active: true,
        removable: true
      },
      {
        field: 'taf',
        active: true,
        removable: true
      },
      {
        field: 'tipo_tac',
        active: true,
        removable: true
      }
    ]
  },
  {
    module: 'EXP_MODELO_TRANSP',
    colunas: [
      {
        active: true,
        removable: true,
        field: 'codigo'
      },
      {
        active: true,
        removable: false,
        field: 'nome'
      },
      {
        active: true,
        removable: true,
        field: 'marca.nome'
      }
    ]
  },
  {
    module: 'EXP_MOTORISTA',
    colunas: [
      {
        field: 'parceiro.nome_razao_social',
        active: true,
        removable: false
      },
      {
        field: 'parceiro.apelido_nome_fantasia',
        active: true,
        removable: true
      },
      {
        field: 'parceiro.cpf_cnpj',
        active: true,
        removable: true
      },
      {
        field: 'cnh',
        active: true,
        removable: true
      },
      {
        field: 'cnh_categoria',
        active: true,
        removable: true
      }
    ]
  },
  {
    module: 'EXP_VEICULO',
    colunas: [
      {
        active: true,
        removable: false,
        field: 'placa'
      },
      {
        active: true,
        removable: true,
        field: 'chassi'
      },
      {
        active: true,
        removable: true,
        field: 'motorista.parceiro.nome_razao_social'
      },
      {
        active: true,
        removable: true,
        field: 'modelo_veiculo.nome'
      }
    ]
  },
  {
    module: 'EXPEDICAO',
    colunas: [
      {
        active: true,
        removable: true,
        field: 'codigo'
      },
      {
        active: true,
        removable: false,
        field: 'destino'
      },
      {
        active: true,
        removable: true,
        field: 'motorista.parceiro.nome_razao_social'
      },
      {
        active: true,
        removable: true,
        field: 'veiculo.modelo_veiculo.nome'
      },
      {
        active: true,
        removable: true,
        field: 'qtd_itens_pedido'
      },
      {
        active: true,
        removable: true,
        field: 'valor_total'
      },
      {
        active: true,
        removable: true,
        field: 'data_emissao'
      },
      {
        active: true,
        removable: true,
        field: 'data_saida'
      },
      {
        active: true,
        removable: true,
        field: 'tipo'
      },
      {
        active: true,
        removable: true,
        field: 'status'
      }
    ]
  }
] as IColunasSettingsUser[];
